import { combineReducers } from "redux";
import salesInvoice from "./salesInvoice";
import composerInvoice from "./composerInvoice";
import advanced from "./advanced";
import payment from "./payment";
import loan from "./loan";
import costAllocation from "./costAllocation";
import upload from "./upload";
import advanceComposer from "./advanceComposer";
import balance from "./balance";

const transactionReducer = combineReducers({
    salesInvoice,
    composerInvoice,
    advanced,
    payment,
    loan,
    costAllocation,
    upload,
    advanceComposer,
    balance
});

export default transactionReducer;